var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Property, ChildProperty, Complex } from '@syncfusion/ej2-base';
/**
 * Defines the properties of both horizontal and vertical guides/rulers to measure the diagram area.
 */
export class DiagramRuler extends ChildProperty {
}
__decorate([
    Property(5)
], DiagramRuler.prototype, "interval", void 0);
__decorate([
    Property(100)
], DiagramRuler.prototype, "segmentWidth", void 0);
__decorate([
    Property('Horizontal')
], DiagramRuler.prototype, "orientation", void 0);
__decorate([
    Property('RightOrBottom')
], DiagramRuler.prototype, "tickAlignment", void 0);
__decorate([
    Property('red')
], DiagramRuler.prototype, "markerColor", void 0);
__decorate([
    Property(25)
], DiagramRuler.prototype, "thickness", void 0);
__decorate([
    Property(null)
], DiagramRuler.prototype, "arrangeTick", void 0);
/**
 * Defines the ruler settings of diagram
 * ```html
 * <div id='diagram'></div>
 * ```
 * ```typescript
 * let diagram: Diagram = new Diagram({
 * ...
 * rulerSettings: { showRulers: true,
 * horizontalRuler: { segmentWidth: 50,interval: 10 },
 * verticalRuler: {segmentWidth: 200,interval: 20}
 * },
 * ...
 * });
 * diagram.appendTo('#diagram');
 * ```
 *
 * @default {}
 */
export class RulerSettings extends ChildProperty {
}
__decorate([
    Property(false)
], RulerSettings.prototype, "showRulers", void 0);
__decorate([
    Property(true)
], RulerSettings.prototype, "dynamicGrid", void 0);
__decorate([
    Complex({ orientation: 'Horizontal' }, DiagramRuler)
], RulerSettings.prototype, "horizontalRuler", void 0);
__decorate([
    Complex({ orientation: 'Vertical' }, DiagramRuler)
], RulerSettings.prototype, "verticalRuler", void 0);
